module.exports = __webpack_public_path__ + "static/media/slide1Active.8f444951.png";